import { useKDSStore, Station } from '../stores/kdsStore';
import {
  LayoutGrid,
  Send,
  Flame,
  ChefHat,
  Droplets,
  Salad,
  Cake,
  Beer,
} from 'lucide-react';
import clsx from 'clsx';

const stations: Array<{ id: Station; label: string; icon: typeof LayoutGrid }> = [
  { id: 'all', label: 'All', icon: LayoutGrid },
  { id: 'expo', label: 'Expo', icon: Send },
  { id: 'grill', label: 'Grill', icon: Flame },
  { id: 'saute', label: 'Sauté', icon: ChefHat },
  { id: 'fry', label: 'Fry', icon: Droplets },
  { id: 'salad', label: 'Salad', icon: Salad },
  { id: 'dessert', label: 'Dessert', icon: Cake },
  { id: 'bar', label: 'Bar', icon: Beer },
];

interface StationSelectorProps {
  ticketCounts?: Record<string, number>;
}

export default function StationSelector({ ticketCounts = {} }: StationSelectorProps) {
  const { selectedStation, setSelectedStation } = useKDSStore();

  return (
    <div
      className="flex gap-2 sm:gap-3 overflow-x-auto scrollbar-hide py-1 px-1 -mx-1"
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {stations.map(({ id, label, icon: Icon }) => {
        const count = ticketCounts[id] || 0;
        const isActive = selectedStation === id;

        return (
          <button
            key={id}
            onClick={() => setSelectedStation(id)}
            className={clsx(
              'station-btn flex items-center gap-2 flex-shrink-0 btn-press',
              isActive && 'active'
            )}
          >
            <Icon className="w-5 h-5 sm:w-6 sm:h-6" />
            <span className="text-sm sm:text-base font-semibold">{label}</span>
            {count > 0 && (
              <span
                className={clsx(
                  'px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full text-xs sm:text-sm font-bold min-w-[1.5rem] text-center',
                  isActive ? 'bg-white/20' : 'bg-slate-700'
                )}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
